class CollapsibleContentCategories {
  constructor() {
    this.init();
  }

  init() {
    const sections = document.querySelectorAll('.collapsible-content');
    sections.forEach(section => this.initSection(section));
  }

  initSection(section) {
    // Check if it's using the aomai layout
    const isaomaiLayout = section.classList.contains('aomai-layout');
    
    if (isaomaiLayout) {
      this.initaomaiLayout(section);
    } else {
      this.initTraditionalLayout(section);
    }
  }

  initaomaiLayout(section) {
    const categoryButtons = section.querySelectorAll('.aomai-category-button');
    const faqItems = section.querySelectorAll('.aomai-faq-item[data-category]');

    if (categoryButtons.length === 0 || faqItems.length === 0) return;

    // Set up initial state
    this.setInitialActiveCategory(section.querySelectorAll('.aomai-category-button'), faqItems, true);

    // Add click event listeners to category buttons
    section.querySelectorAll('.aomai-category-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCategoryClick(button, section.querySelectorAll('.aomai-category-button'), faqItems, true);
      });
    });

    // Set up FAQ toggle functionality
    faqItems.forEach(item => {
      const summary = item.querySelector('.aomai-faq-header');
      const icon = item.querySelector('.aomai-faq-icon');
      
      if (summary && icon) {
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleFaqItem(item, icon, faqItems);
        });
      }
    });
  }

  initTraditionalLayout(section) {
    const categoryButtons = section.querySelectorAll('.category-button');
    const accordions = section.querySelectorAll('.accordion[data-category]');

    if (categoryButtons.length === 0 || accordions.length === 0) return;

    // Set up initial state
    this.setInitialActiveCategory(section.querySelectorAll('.category-button'), accordions, false);

    // Add click event listeners to category buttons
    section.querySelectorAll('.category-button').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleCategoryClick(button, section.querySelectorAll('.category-button'), accordions, false);
      });
    });
  }

  setInitialActiveCategory(buttons, items, isaomaiLayout) {
    const activeButtonClass = isaomaiLayout ? 'aomai-category-button--active' : 'category-button--active';
    const activeButton = Array.from(buttons).find(btn => btn.classList.contains(activeButtonClass));
    
    if (activeButton) {
      const activeCategory = activeButton.dataset.category;
      this.filterItems(items, activeCategory, isaomaiLayout);
    } else if (buttons.length > 0) {
      // If no active button, activate the first one
      const buttonToActivate = buttons[0];
      
      buttonToActivate.classList.add(activeButtonClass);
      const category = buttonToActivate.dataset.category;
      this.filterItems(items, category, isaomaiLayout);
    }
  }

  handleCategoryClick(clickedButton, allButtons, items, isaomaiLayout) {
    const activeButtonClass = isaomaiLayout ? 'aomai-category-button--active' : 'category-button--active';
    
    // Remove active class from all buttons
    allButtons.forEach(btn => btn.classList.remove(activeButtonClass));
    
    // Add active class to clicked button
    clickedButton.classList.add(activeButtonClass);
    
    // Filter items based on selected category
    const selectedCategory = clickedButton.dataset.category;
    this.filterItems(items, selectedCategory, isaomaiLayout);
  }

  filterItems(items, activeCategory, isaomaiLayout) {
    items.forEach(item => {
      const itemCategory = item.dataset.category;
      
      if (itemCategory === activeCategory) {
        item.classList.remove('hidden');
        // Small delay for smooth transition
        setTimeout(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        }, 10);
      } else {
        item.style.opacity = '0';
        item.style.transform = 'translateY(-10px)';
        // Hide element after transition
        setTimeout(() => {
          item.classList.add('hidden');
        }, 300);
      }
    });
  }

  toggleFaqItem(item, icon, allFaqItems) {
    const isCurrentlyOpen = item.hasAttribute('open');
    
    // Close all FAQ items first
    allFaqItems.forEach(faqItem => {
      const faqIcon = faqItem.querySelector('.aomai-faq-icon');
      if (faqItem.hasAttribute('open')) {
        faqItem.removeAttribute('open');
        if (faqIcon) {
          faqIcon.textContent = '+';
        }
      }
    });
    
    // If the clicked item wasn't open, open it
    if (!isCurrentlyOpen) {
      item.setAttribute('open', '');
      icon.textContent = '−';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollapsibleContentCategories();
});

// Re-initialize for theme editor
document.addEventListener('shopify:section:load', () => {
  new CollapsibleContentCategories();
});

// Handle theme editor updates
document.addEventListener('shopify:section:select', () => {
  new CollapsibleContentCategories();
});
